import { styled as r } from "styled-components";
import { Icon as e } from "../../../../../components/Icon/index.js";
import { CaptionLight as t } from "../../../../../styles/typography/index.js";
import { Theme as o } from "../../../../../styles/themes/index.js";
const s = r.div`
  ${t}
  display: flex;
  align-items: center;
  strong {
    margin-left: 3px;
  }
`, c = r.div`
  &[aria-disabled='true'] {
    color: rgb(${o.colors.Golf});
  }
`, d = r(e)`
  font-size: 24px;
  color: rgb(${o.colors.Brand});

  &[aria-disabled='true'] {
    color: rgb(${o.colors.Golf});
  }
`;
export {
  d as FlagIcon,
  s as HeaderAlertContainer,
  c as HeaderAlertText
};
